/* Paragon build sheet — companion patches (loads after the main script) */
(function () {
  var bypass = false;

  function allDone() {
    var r = document.querySelectorAll('#rail i');
    if (!r.length) return true;                 // rail not built yet: don't block
    return Array.prototype.every.call(r, function (i) { return i.classList.contains('on'); });
  }

  // 1. warn before PDF / copy-link when the sheet is incomplete
  document.addEventListener('click', function (e) {
    if (bypass) return;
    var t = e.target.closest ? e.target.closest('#dockPdf,#dockLink,#pdf,#link') : null;
    if (!t || allDone()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (window.confirm('Not all steps have been completed. Are you sure you want to proceed?')) {
      bypass = true;
      try { t.click(); } finally { bypass = false; }
    }
  }, true);

  // 2. the van is drawn as adjacent slices; overlap them 1px so no seam shows through the body
  function deseam() {
    var s = document.getElementById('vanSide');
    if (!s) return;
    Array.prototype.forEach.call(s.children, function (c) {
      if (c.tagName !== 'svg' || c.dataset.seam) return;
      var w = parseFloat(c.getAttribute('width'));
      var x = parseFloat(c.getAttribute('x')) || 0;
      var vb = (c.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
      if (!w || vb.length !== 4) return;
      c.dataset.seam = '1';
      if (x <= 0) return;                        // first slice has no seam to its left
      var k = vb[2] / w;                         // user units per px
      c.setAttribute('x', x - 1);
      c.setAttribute('width', w + 1);
      c.setAttribute('viewBox', (vb[0] - k) + ' ' + vb[1] + ' ' + (vb[2] + k) + ' ' + vb[3]);
    });
  }
  var vs = document.getElementById('vanSide');
  if (vs && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(deseam, 0); }).observe(vs, { childList: true });
  }

  // 3. "No cutouts" — completes the step, clears any entered cutouts and locks the fields
  var noCuts = false, applying = false;

  function cutRows() { return document.querySelectorAll('#cuts .cut'); }
  function isTent(row) { return row.dataset && row.dataset.id === 'tent'; }

  function clearCuts() {
    // drop user-added cutouts, newest first (the Super Pacific tent row stays — it is rack geometry)
    var rows = Array.prototype.slice.call(cutRows()).reverse();
    rows.forEach(function (row) {
      if (isTent(row)) return;
      var rm = row.querySelector('.cutrow .linkbtn');
      if (rm) rm.click();
    });
    // blank anything still on screen so no stale numbers survive
    Array.prototype.forEach.call(document.querySelectorAll('#cuts input'), function (i) {
      var row = i.closest ? i.closest('.cut') : null;
      if (row && isTent(row)) return;
      if (i.disabled || !i.value) return;
      i.value = '';
      i.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function lockCuts(on) {
    var box = document.getElementById('cuts');
    if (box) box.classList.toggle('nc-locked', on);
    var add = document.getElementById('addCut');
    if (add) add.classList.toggle('nc-dim', on);
    var hint = document.getElementById('noCutsHint');
    if (hint) hint.style.display = on ? 'block' : 'none';
  }

  function markNoCuts() {
    if (!noCuts) return;
    applying = true;
    try {
      var step = document.querySelector('.pgb .step[data-step="cut"]');
      if (step) step.classList.add('done');
      var rail = document.querySelectorAll('#rail i');
      if (rail.length) rail[rail.length - 1].classList.add('on');
      var prog = document.getElementById('progress');
      if (prog && rail.length) prog.textContent = document.querySelectorAll('#rail i.on').length + ' of ' + rail.length;
      lockCuts(true);
      var first = true;
      Array.prototype.forEach.call(document.querySelectorAll('#sum dt'), function (dt) {
        if (dt.textContent.indexOf('Cutout') !== 0) return;
        var dd = dt.nextElementSibling;
        if (first) { dt.textContent = 'Roof cutouts'; if (dd) dd.textContent = 'None \u2014 no cutouts required'; first = false; }
        else { dt.style.display = 'none'; if (dd) dd.style.display = 'none'; }
      });
    } finally { applying = false; }
  }

  function releaseNoCuts() {
    applying = true;
    try {
      var s = document.querySelector('.pgb .step[data-step="cut"]');
      if (s) s.classList.remove('done');
      var rail = document.querySelectorAll('#rail i');
      if (rail.length) rail[rail.length - 1].classList.remove('on');
      var prog = document.getElementById('progress');
      if (prog && rail.length) prog.textContent = document.querySelectorAll('#rail i.on').length + ' of ' + rail.length;
      lockCuts(false);
      Array.prototype.forEach.call(document.querySelectorAll('#sum dt,#sum dd'), function (el) { el.style.display = ''; });
    } finally { applying = false; }
  }

  // Super Pacific racks always carry the tent cutout, so "No cutouts" cannot apply
  function isSuperPacific() {
    var on = document.querySelector('[data-set="rack"] .opt.on');
    return !!(on && (on.dataset.v === 'sp' || on.dataset.v === 'spc'));
  }

  function syncNoCutsAvailability() {
    var btn = document.getElementById('noCuts');
    var na = document.getElementById('noCutsNA');
    if (!btn) return;
    var blocked = isSuperPacific();
    btn.disabled = blocked;
    btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    if (na) na.style.display = blocked ? 'block' : 'none';
    if (blocked && noCuts) {                       // switching to SP releases it
      noCuts = false;
      btn.classList.remove('on');
      releaseNoCuts();
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('#noCuts,#addCut') : null;
    if (!t) return;
    if (t.id === 'addCut') {                       // adding a cutout always re-enables the step
      if (noCuts) { noCuts = false; var b = document.getElementById('noCuts'); if (b) b.classList.remove('on'); releaseNoCuts(); }
      return;
    }
    if (isSuperPacific()) return;                  // button is inert on Super Pacific builds
    noCuts = !noCuts;
    t.classList.toggle('on', noCuts);
    if (noCuts) { clearCuts(); markNoCuts(); } else { releaseNoCuts(); }
  });

  // the main script re-renders on every change, so re-apply afterwards
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-set="rack"] .opt')) setTimeout(syncNoCutsAvailability, 0);
  });
  syncNoCutsAvailability();
  if (window.MutationObserver) {
    var rackBox = document.querySelector('[data-set="rack"]');
    if (rackBox) new MutationObserver(function () { syncNoCutsAvailability(); })
      .observe(rackBox, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  ['rail', 'sum', 'cuts'].forEach(function (id) {
    var n = document.getElementById(id);
    if (n && window.MutationObserver) {
      new MutationObserver(function () { if (!applying) setTimeout(markNoCuts, 0); })
        .observe(n, { childList: true, subtree: true, characterData: true });
    }
  });
})();
